import { routeFactory } from "@/RouteFactory";
import { Link } from "@/components/Link";
import { Indent } from "@stenajs-webui/core";
import { StandardTableConfig } from "@stenajs-webui/grid";
import { childCustomersTableCell } from "../components/ChildCustomersTableCell";
import { ChildCustomersTableItem } from "../types";

export const childCustomersTableConfig: StandardTableConfig<
  ChildCustomersTableItem,
  "custIndex" | "name" | "custNo"
> = {
  enableGridCell: false,
  initialSortOrder: "custIndex",
  keyResolver: (item) => item.id,
  columns: {
    custIndex: {
      itemValueResolver: (item) => item.custIndex,
      renderCell: ({ item }) => (
        <Indent>
          <Link
            to={routeFactory.productAndPrice.customer.customer({
              customerId: String(item.custNo),
            })}
          >
            {item.custIndex}
          </Link>
        </Indent>
      ),
      columnLabel: "Index",
    },
    name: {
      itemValueResolver: (item) => item.name,
      renderCell: ({ item }) => childCustomersTableCell(item.name),
      columnLabel: "Name",
    },
    custNo: {
      itemValueResolver: (item) => item.custNo,
      renderCell: ({ item }) => childCustomersTableCell(item.custNo),
      columnLabel: "Customer number",
    },
  },
  columnOrder: ["custIndex", "name", "custNo"],
};
